<template>
    <NuxtLayout name="malt-base-layout">
        <VJoyFunnel hide-shapes layout-width="large">
            <template #funnel-header>
                <VJoyFunnelHeader>
                    <template #funnel-header-left>
                        <NuxtLink to="/" external>
                            <MaltImg src="/navbar/logos/malt-logo-red.svg?vh=9690b2" width="125" height="35" alt="Malt logo" />
                        </NuxtLink>
                    </template>
                </VJoyFunnelHeader>
            </template>

            <slot />
        </VJoyFunnel>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {watch} from 'vue';
    import {useRoute} from '@typed-router';
    import {MaltImg} from '#components';
    import {useHead, useLocale, useTranslation} from '#imports';
    import {VJoyFunnel, VJoyFunnelHeader} from '@maltjoy/core-vue';

    const route = useRoute();
    const {locale} = useLocale();
    const {t} = useTranslation();

    useHead({
        title: t('project.submission.page.title'),
        htmlAttrs: {
            lang: locale.value,
        },
    });

    watch(
        () => route.name,
        () => {
            document.querySelector('.joy-funnel__scrollable')?.scrollTo({
                top: 0,
            });
        },
    );
</script>

<style scoped lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    // FIXME: to fix in the DS
    :deep(.joy-funnel__content) {
        @include mq.screen_sm {
            padding-top: 0;
        }
    }
</style>
